var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23777 45.6014C10.3007 49.392 15.5654 51.3447 21.1162 51.0001C31.2449 50.3109 39.428 41.8683 39.8286 31.7602C39.8858 30.0373 39.3708 26.4765 39.0275 24.8109L38.6841 25.5001C38.0547 26.7636 37.2535 27.9123 36.2235 28.8886L25.6941 39.169C25.5797 39.2839 25.5225 39.3413 25.408 39.4562C24.1491 40.6048 22.604 41.4089 20.6584 41.5237C17.7399 41.696 14.9359 40.7197 12.8186 38.7096C10.7013 36.6994 9.49958 33.9427 9.49958 31.0136C9.49958 30.267 9.84293 29.4629 10.4724 28.8312L27.2964 12.2906C25.1791 10.2805 22.3751 9.30416 19.4567 9.47645C14.9931 9.76362 7.72562 13.8988 8.35509 17.5744L3.83434 22.0542C3.14765 22.7433 2.51818 23.49 2.00315 24.294C0.744211 26.3042 0.000291879 28.6015 0.000291668 31.0136C0.000291186 36.5271 2.28928 41.8109 6.23777 45.6014Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.972821 26.1889L1.94564 24.2936C2.46066 23.4896 3.09013 22.6855 3.77683 22.0538L13.9056 11.8882C14.3634 11.4862 14.8212 11.1416 15.1073 10.9119C16.309 10.0504 17.7396 9.53349 19.3419 9.41862C22.2604 9.24633 25.0644 10.2227 27.1817 12.2328C29.299 14.2429 30.5007 16.9997 30.5007 19.9288C30.5007 20.6754 30.1574 21.4794 29.5279 22.1112L12.6466 38.6517C14.7639 40.6619 17.568 41.6382 20.4864 41.4659C22.432 41.3511 23.9771 40.547 25.2361 39.3984L25.5222 39.1112L36.166 28.9456C37.196 27.9693 37.9971 26.7632 38.6266 25.5571C39.485 23.7767 40 21.8815 40 19.9862C40 14.4727 37.711 9.1889 33.7053 5.39836C29.6423 1.60782 24.3777 -0.344891 18.8269 -0.000296828C8.75537 0.631459 0.572249 9.07403 0.171676 19.2396C0.114451 20.9051 0.629473 24.5808 0.972821 26.1889Z",
    fill: "url(#paint0_linear_117_3111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_3111",
    x1: 20.0849,
    y1: 41.5608,
    x2: 20.0849,
    y2: -0.0250491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#203DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#095AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#0065FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/LogoWhite.3dcfcc8daa14c5d50d0e624a956ef364.svg";
export { ForwardRef as ReactComponent };